export default __webpack_public_path__ + "static/media/commitment.33460141.jpg";